import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import { Link } from 'react-router-dom';
import Table from '../../core/common/dataTable/index'; 
import api from '../../api';
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import useDynamicPageSize from '../../useDynamicPageSize';
import Footer from '../../Footer';
import 'bootstrap/dist/css/bootstrap.min.css';  
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast, ToastContainer } from "react-toastify";


type DocumentHeaderType = {
  id: number;
  document_type: string;
  is_exit_only: boolean;
};
type ModalMode = "add" | "edit";

const DocumentHeader: React.FC = () => {
  const { setFilters } = useHeaderFilters();
  // pagination & data
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = useDynamicPageSize();
  const isInitialFetch = useRef(true);
  const [totalItems, setTotalItems] = useState(0);
  const [documents, setDocument] = useState<DocumentHeaderType[]>([]);
  const [loading, setLoading] = useState(true);
  const [tableHeight, setTableHeight] = useState<number>(0);
	
	useLayoutEffect(() => {
    if (pageSize === 0) return;
	  const calculateHeight = () => {
		const baseOffset = 194;
		const extraOffset = window.innerWidth <= 991 ? -43 : -81;
		const fixedOffset = baseOffset + extraOffset;
	
		const newHeight = window.innerHeight - fixedOffset;
	
		console.log('Calculated table height:', newHeight);
		console.log('fixedOffset:', fixedOffset);
		console.log('window.innerHeight:', window.innerHeight);
		console.log('pagesize:',pageSize);
		console.log('totalItems',totalItems);
	
		setTableHeight(newHeight);
	  };
	
	calculateHeight(); // initial + on totalItems change
  window.addEventListener("resize", calculateHeight);


    calculateHeight(); // initial + on totalItems change
    window.addEventListener("resize", calculateHeight);

    return () => window.removeEventListener("resize", calculateHeight);
  }, [totalItems, pageSize]);

  // form state
  const [formData, setFormData] = useState({ document_type: "", is_exit_only: false });
  const [formError, setFormError] = useState("");
  const [editId, setEditId] = useState<number | null>(null);
  const [modalMode, setModalMode] = useState<ModalMode>("add");

  // fetch
  const fetchDocumentHeader = async () => {
    try {
      setLoading(true);
      const res = await api("/document-header", {
        method: "POST",
        body: { currentPage, pageSize },
      });

      // Type assertion: Assuming res is of type 'ApiResponse'
      const apiData = (res as { documents: any }).documents;

      console.log("apidata", apiData);

      setDocument(
        apiData.data.map((rec: any) => ({
          id: rec.id,
          document_type: rec.document_type,
          is_exit_only: !!rec.is_exit_only,
        }))
      );

      setTotalItems(apiData.total);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoading(false);
    }
  };
    useEffect(() => {  if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchDocumentHeader(); }, [currentPage, pageSize]
  );
 
  useEffect(() => {
    const DocumentHeaderFilters = () => (
      <div className="px-2 px-md-2">
        <div className="document-filters d-flex align-items-center flex-wrap ">
          <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={() => openModal("add")}
            >
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
    );

    setFilters(<DocumentHeaderFilters />);
    return () => {
      console.log("cleaning up filters");
      setFilters(null);
    };
  }, []);

  // open modal (add or edit)
  const openModal = (mode: ModalMode, rec?: DocumentHeaderType) => {
    setFormError("");
    setModalMode(mode);
    setFormData({ document_type: "", is_exit_only: false });
    setEditId(null);

    if (mode === "edit" && rec) {
      setFormData({ document_type: rec.document_type, is_exit_only: rec.is_exit_only });
      setEditId(rec.id);
    }

    const el = document.getElementById("document_header_modal");
    if (el) {
      const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
      bsModal.show();
    }
  };

  // hide modal + backdrop cleanup
  const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el || !(window as any).bootstrap?.Modal) return;

    const instance = (window as any).bootstrap.Modal.getInstance(el);
    if (instance) {
      instance.hide();
    }

    // after fade, remove any stray backdrops & body locks
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };

  // form handlers
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val.trim()) setFormError("");
    setFormData((prev) => ({ ...prev, document_type: val }));
  };

  const handleExitOnlyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, is_exit_only: e.target.checked }));
  };

  const handleSubmit = async () => {
    if (!formData.document_type.trim()) {
      setFormError("Document type is required.");
      return;
    }
    try {
      const body: any = {
        document_type: formData.document_type.trim(),
        is_exit_only: formData.is_exit_only,
      };
      if (modalMode === "edit" && editId != null) body.id = editId;
      const res = await api<{ success: boolean; error?: string }>(
        "/save-document-header",
        { method: "POST", body }
      );
      if (res.success) {
        if (modalMode === "edit") {
          await fetchDocumentHeader();
        } else {
          // For add mode:
          setTotalItems((prevCount) => {
                const newCount = prevCount + 1;
                setCurrentPage(1);
                fetchDocumentHeader();
                return newCount;
          });
        }

        hideModal("document_header_modal");
        toast.success(
          modalMode === "add"
            ? "Document Header added successfully!"
            : "Document Header updated successfully!"
        );
      } else {
        const msg = res.error?.toLowerCase().includes("duplicate")
          ? "Duplicate header! Document already exists."
          : res.error || "Failed to save Document Header.";
        toast.error(msg);
      }
    } catch (err: any) {
        if (err.response?.data) {
          const data = err.response.data;
          const msg =
            data.error ||
            data.message ||
            err.message ||
            "Something went wrong.";
          toast.error(msg);
        } else {
          toast.error(err.message || "Something went wrong.");
        }
      }
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await api<{ success: boolean; error?: string }>(
        `/document/delete/${id}`,
        { method: "DELETE" }
      );
      if (res.success) {
        setTotalItems((prevCount) => prevCount - 1);
        toast.success("Document Header deleted successfully!");
        // Calculate the total pages after deletion
        const totalPages = Math.ceil((totalItems - 1) / pageSize);
        // If the current page number is now greater than totalPages, move back one page
        if (currentPage > totalPages) {
          setCurrentPage(totalPages > 0 ? totalPages : 1);
        } else {
          fetchDocumentHeader();
        }
      } else {
        toast.error(res.error || "Failed to delete Document Header.");
      }
    } catch (err: any) {
        if (err.response?.data) {
          const data = err.response.data;
          const msg =
            data.error ||
            data.message ||
            err.message ||
            "Something went wrong.";
          toast.error(msg);
        } else {
          toast.error(err.message || "Something went wrong.");
        }
      }
  };
  const openDeleteModal = (id: number) => {
    setEditId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };
  // table columns
  const columns = [
    {
      title: "Document Type",
      dataIndex: "document_type",
      width: "50%",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Applicable To",
      dataIndex: "is_exit_only",
      width: "20%",
      render: (_: any, rec: DocumentHeaderType) =>
        rec.is_exit_only ? (
          <span className="badge badge-soft-warning">
            Released / Notice Period / Terminated only
          </span>
        ) : (
          <span className="badge badge-soft-success">All Employees</span>
        ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, rec: DocumentHeaderType) => (
        <div className="action-icon d-inline-flex">
          <Link to="#" onClick={() => openModal("edit", rec)}>
            <i className="ti ti-edit" />
          </Link>
          <Link to="#" onClick={() => openDeleteModal(rec.id)}>
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
    <div className="page-wrapper d-flex flex-column">
      <div className="content flex-grow-1">
        <div className="card card-margin-bottom">
          <div className="card-body p-0" id="Document-list" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
            <Table
            style={{ flex: 1 }}
            currentPage={currentPage}
              dataSource={documents}
              columns={columns}
              onPageChange={setCurrentPage}
              totalItems={totalItems}
              pageSize={pageSize}
              loading={loading}
            />
          </div>
        </div>
      </div>
      {/* Add/Edit Modal */}
      <div className="modal fade" id="document_header_modal">
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {modalMode === "add" ? "Add Document" : "Edit Document"}
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => hideModal("document_header_modal")}
              />
            </div>
            <div className="modal-body pb-0">
              <div className="mb-3">
                <label className="form-label">Document Type</label>
                <input
                  type="text"
                  className="form-control"
                  name="document_type"
                  onChange={handleInputChange}
                  value={formData.document_type}
                />
                {formError && (
                  <small className="text-danger">{formError}</small>
                )}
              </div>
              <div className="mb-3 form-check">
                <input
                  id="document_header_is_exit_only"
                  className="form-check-input"
                  type="checkbox"
                  checked={formData.is_exit_only}
                  onChange={handleExitOnlyChange}
                />
                <label
                  className="form-check-label"
                  htmlFor="document_header_is_exit_only"
                >
                  Show only for Released / Notice Period / Terminated employees
                </label>
                <div>
                  <small className="text-muted">
                    If unchecked, this document will be shown for all employees.
                  </small>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-light me-2"
                onClick={() => hideModal("document_header_modal")}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                {modalMode === "add" ? "Add" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div id="top-modal" className="modal fade" tabIndex={-1}>
        <div className="modal-dialog modal-top">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Delete Document Header</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-cancel" data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => editId !== null && handleDelete(editId)}
                data-bs-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <Footer />
      </div>
    </div>
    <ToastContainer position="top-right" autoClose={3000} /></>
  );
};

export default DocumentHeader;
